import { generateUUID } from '@/utils/generate_uuid'
import { getOpenId } from '@/defines/user/getters/get_open_id'
import { miniProgramEnv } from './detect_mp'
import Url from '@mc/mc-utils/js/url/url'

const getFromUrl = () => {
  const url = new Url(window.location.href)
  const { device_id: deviceId } = url.parseQuerystring()
  return deviceId
}

export const getDeviceId = (platform, appInfo) => {
  if (appInfo.deviceId) return appInfo.deviceId
  if (miniProgramEnv.isMiniProgram) {
    return getFromUrl()
  }
  if (getOpenId()) return getOpenId()
  let vDeviceId = localStorage.getItem('mc_vDeviceId')
  if (!vDeviceId) {
    vDeviceId = generateUUID()
    localStorage.setItem('mc_vDeviceId', vDeviceId)
  }
  return vDeviceId
}
